jQuery(document).on('gform_post_render', function() {

    jQuery('#field_6_14').click(function() {
        if (jQuery('#choice_6_14_1').is(':checked') && jQuery('#choice_6_14_2').is(':checked') && jQuery('#choice_6_14_3').is(':checked') ) {
            jQuery('#field_6_14 .alertmessage').remove();
            jQuery('#field_6_14 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_6_14 .alertmessage').remove();
            jQuery('#field_6_14 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – these are all a part of bathing.</div>");
        }

    });
    jQuery('#field_6_14').click(function() {
        if (!jQuery('#choice_6_14_1').is(':checked') && !jQuery('#choice_6_14_2').is(':checked') && !jQuery('#choice_6_14_3').is(':checked') ) {
            jQuery('#field_6_14 .alertmessage').remove();
        }

    });
    jQuery('#field_6_11').click(function() {
        if (jQuery('#choice_6_11_1').is(':checked') && jQuery('#choice_6_11_2').is(':checked') && jQuery('#choice_6_11_3').is(':checked') && jQuery('#choice_6_11_4').is(':checked') && jQuery('#choice_6_11_5').is(':checked') ) {
            jQuery('#field_6_11 .alertmessage').remove();
            jQuery('#field_6_11 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_6_11 .alertmessage').remove();
            jQuery('#field_6_11 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking! All these questions might be helpful.</div>");
        }

    });

    jQuery('#field_6_11').click(function() {
        if (!jQuery('#choice_6_11_1').is(':checked') && !jQuery('#choice_6_11_2').is(':checked') && !jQuery('#choice_6_11_3').is(':checked') && !jQuery('#choice_6_11_4').is(':checked') && !jQuery('#choice_6_11_5').is(':checked') ) {
            jQuery('#field_6_11 .alertmessage').remove();
        }

    });

    jQuery('#field_6_12').click(function() {

        if (jQuery('#choice_6_12_1').is(':checked') && jQuery('#choice_6_12_2').is(':checked') && !jQuery('#choice_6_12_3').is(':checked') && !jQuery('#choice_6_12_4').is(':checked')) {
            jQuery('#field_6_12 .alertmessage').remove();
            jQuery('#field_6_12 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_6_12 .alertmessage').remove();
            jQuery('#field_6_12 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking! There is one more example of Raina supporting Lou.</div>");
        }


    });
    jQuery('#field_6_12').click(function() {
        if (!jQuery('#choice_6_12_1').is(':checked') && !jQuery('#choice_6_12_2').is(':checked') && !jQuery('#choice_6_12_3').is(':checked') && !jQuery('#choice_6_12_4').is(':checked')) {
            jQuery('#field_6_12 .alertmessage').remove();

        }

    });

    jQuery('#field_6_12').click(function() {

        if (jQuery('#choice_6_12_3').is(':checked')) {
            jQuery('#field_6_12 .alertmessage').remove();
            jQuery('#field_6_12 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_12_4').is(':checked')) {
            jQuery('#field_6_12 .alertmessage').remove();
            jQuery('#field_6_12 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_12_4').is(':checked') && jQuery('#choice_6_12_3').is(':checked')) {
            jQuery('#field_6_12 .alertmessage').remove();
            jQuery('#field_6_12 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }


    });

    jQuery('#field_6_12').click(function() {
        if (jQuery('#choice_6_12_3').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_12_3').remove();
            jQuery('.gchoice_6_12_3 ').after("<div class='alertmessage insidecheckbox gchoice_6_12_3'>If a person is angry, it might be best to let them reset before trying to help them again.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_12_3').remove();

        }
    });
    jQuery('#field_6_12').click(function() {
        if (jQuery('#choice_6_12_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_12_4').remove();
            jQuery('.gchoice_6_12_4 ').after("<div class='alertmessage insidecheckbox gchoice_6_12_4'>Having dementia does not automatically make a person not want to shower. Having dementia can cause a person to think and act differently because they are confused about what is happening, or having trouble explaining what they want or don’t want.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_12_4').remove();

        }
    });
    jQuery('#field_6_13').click(function() {
        if (jQuery('#choice_6_13_1').is(':checked') && jQuery('#choice_6_13_2').is(':checked') && jQuery('#choice_6_13_3').is(':checked') && !jQuery('#choice_6_13_4').is(':checked') && !jQuery('#choice_6_13_5').is(':checked') && !jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking! There are more examples of honoring your loved one’s bathing preferences.</div>");
        }

    });

    jQuery('#field_6_13').click(function() {
        if (!jQuery('#choice_6_13_1').is(':checked') && !jQuery('#choice_6_13_2').is(':checked') && !jQuery('#choice_6_13_3').is(':checked') && !jQuery('#choice_6_13_4').is(':checked') && !jQuery('#choice_6_13_5').is(':checked') && !jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
        }

    });

    jQuery('#field_6_13').click(function() {
        if (jQuery('#choice_6_13_4').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_13_5').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_13_4').is(':checked') && jQuery('#choice_6_13_5').is(':checked') && !jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (!jQuery('#choice_6_13_4').is(':checked') && jQuery('#choice_6_13_5').is(':checked') && jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_13_4').is(':checked') && !jQuery('#choice_6_13_5').is(':checked') && jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_13_4').is(':checked') && jQuery('#choice_6_13_5').is(':checked') && jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('#field_6_13 .alertmessage').remove();
            jQuery('#field_6_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }

    });

    jQuery('#field_6_13').click(function() {
        if (jQuery('#choice_6_13_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_13_4').remove();
            jQuery('.gchoice_6_13_4').after("<div class='alertmessage insidecheckbox gchoice_6_13_4'>Arya’s care partner is not honoring Arya’s preference of showering tomorrow.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_13_4').remove();

        }

    });

    jQuery('#field_6_13').click(function() {
        if (jQuery('#choice_6_13_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_13_5').remove();
            jQuery('.gchoice_6_13_5').after("<div class='alertmessage insidecheckbox gchoice_6_13_5'>Jacob’s care partner is honoring her preferences for music, not Jacob’s.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_13_5').remove();

        }

    });

    jQuery('#field_6_13').click(function() {
        if (jQuery('#choice_6_13_6').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_13_6').remove();
            jQuery('.gchoice_6_13_6').after("<div class='alertmessage insidecheckbox gchoice_6_13_6'>Maeve’s care partner is basing her actions on what is easier for her, not what Maeve wants.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_13_6').remove();
        }

    });

    jQuery('#field_6_15').click(function() {
        if (jQuery('#choice_6_15_1').is(':checked') && jQuery('#choice_6_15_2').is(':checked') && jQuery('#choice_6_15_3').is(':checked') && jQuery('#choice_6_15_4').is(':checked') ) {
            jQuery('#field_6_15 .alertmessage').remove();
            jQuery('#field_6_15 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_6_15 .alertmessage').remove();
            jQuery('#field_6_15 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking! There are more examples of showing support for Alphie.</div>");
        }

    });
    jQuery('#field_6_15').click(function() {
        if (!jQuery('#choice_6_15_1').is(':checked') && !jQuery('#choice_6_15_2').is(':checked') && !jQuery('#choice_6_15_3').is(':checked') && !jQuery('#choice_6_15_4').is(':checked') && !jQuery('#choice_6_15_5').is(':checked') && !jQuery('#choice_6_15_6').is(':checked') ) {
            jQuery('#field_6_15 .alertmessage').remove();

        }

    });
    jQuery('#field_6_15').click(function() {
        if (jQuery('#choice_6_15_5').is(':checked')) {
            jQuery('#field_6_15 .alertmessage').remove();
            jQuery('#field_6_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_15_6').is(':checked')) {
            jQuery('#field_6_15 .alertmessage').remove();
            jQuery('#field_6_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_15_5').is(':checked') && jQuery('#choice_6_15_6').is(':checked')) {
            jQuery('#field_6_15 .alertmessage').remove();
            jQuery('#field_6_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }

    });

    jQuery('#field_6_15').click(function() {
        if (jQuery('#choice_6_15_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_15_5').remove();
            jQuery('.gchoice_6_15_5 ').after("<div class='alertmessage insidecheckbox gchoice_6_15_5'>Tom supports Alphie to do what he can, and he helps Alphie with the things he has difficulty doing.</div>");

        } else {
            jQuery('.alertmessage.gchoice_6_15_5').remove();

        }


    });

    jQuery('#field_6_15').click(function() {
        if (jQuery('#choice_6_15_6').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_15_6').remove();
            jQuery('.gchoice_6_15_6 ').after("<div class='alertmessage insidecheckbox gchoice_6_15_6'>Alphie needs verbal and cognitive support from Tom to do as much as he can, including reminders and a bathing environment that Tom prepares for him.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_15_6').remove();

        }


    });

    jQuery('#field_6_16').click(function() {
        if (jQuery('#choice_6_16_1').is(':checked') && jQuery('#choice_6_16_2').is(':checked') && !jQuery('#choice_6_16_3').is(':checked') && !jQuery('#choice_6_16_4').is(':checked')) {
            jQuery('#field_6_16 .alertmessage').remove();
            jQuery('#field_6_16 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_6_16 .alertmessage').remove();
            jQuery('#field_6_16 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking! There is one more example of Layla supporting Vera.</div>");
        }

    });

    jQuery('#field_6_16').click(function() {
        if (!jQuery('#choice_6_16_1').is(':checked') && !jQuery('#choice_6_16_2').is(':checked') && !jQuery('#choice_6_16_3').is(':checked') && !jQuery('#choice_6_16_4').is(':checked')) {
            jQuery('#field_6_16 .alertmessage').remove();

        }
    });
    jQuery('#field_6_16').click(function() {
        if (jQuery('#choice_6_16_3').is(':checked')) {
            jQuery('#field_6_16 .alertmessage').remove();
            jQuery('#field_6_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_16_4').is(':checked')) {
            jQuery('#field_6_16 .alertmessage').remove();
            jQuery('#field_6_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_6_16_3').is(':checked') && jQuery('#choice_6_16_4').is(':checked')) {
            jQuery('#field_6_16 .alertmessage').remove();
            jQuery('#field_6_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }

    });

    jQuery('#field_6_16').click(function() {
        if (jQuery('#choice_6_16_3').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_16_3').remove();
            jQuery('.gchoice_6_16_3 ').after("<div class='alertmessage insidecheckbox gchoice_6_16_3'>Doing nothing is not giving Vera the support she needs. Vera might be difficult, but Layla needs to try to understand what might be going on with Vera to offer proper support.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_16_3').remove();
        }
    });

    jQuery('#field_6_16').click(function() {
        if (jQuery('#choice_6_16_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_6_16_4').remove();
            jQuery('.gchoice_6_16_4 ').after("<div class='alertmessage insidecheckbox gchoice_6_16_4'>It is important to support your loved one’s choices and not order them to shower. Discuss bathing concerns that may be affecting your loved one’s physical health with their provider.</div>");
        } else {
            jQuery('.alertmessage.gchoice_6_16_4').remove();

        }

    });
    /* Eating Support*/
    jQuery('#field_2_11').click(function() {
        if (jQuery('#choice_2_11_4').is(':checked') && jQuery('#choice_2_11_2').is(':checked') && jQuery('#choice_2_11_3').is(':checked')) {
            jQuery('#field_2_11 .alertmessage').remove();
            jQuery('#field_2_11 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_2_11 .alertmessage').remove();
            jQuery('#field_2_11 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more important eating concepts.</div>");
        }
        if (jQuery('#choice_2_11_1').is(':checked')) {
            jQuery('#field_2_11 .alertmessage').remove();
            jQuery('#field_2_11 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_2_11_1').is(':checked') && !jQuery('#choice_2_11_2').is(':checked') && !jQuery('#choice_2_11_3').is(':checked') && !jQuery('#choice_2_11_4').is(':checked')) {
            jQuery('#field_2_11 .alertmessage').remove();
        }

    });
    jQuery('#field_2_11').click(function() {
        if (jQuery('#choice_2_11_1').is(':checked')) {
            jQuery('.alertmessage.gchoice_2_11_1').remove();
            jQuery('.gchoice_2_11_1 ').after("<div class='alertmessage insidecheckbox gchoice_2_11_1'> When we are supporting a person with eating, we need to really try to ensure a person is eating what they want and in the way they want. This looks different for each person, but we can try our best to make it happen.</div>");
        }
    });
    jQuery('#field_2_12').click(function() {
        if (jQuery('#choice_2_12_1').is(':checked') && jQuery('#choice_2_12_2').is(':checked') && jQuery('#choice_2_12_3').is(':checked')) {
            jQuery('#field_2_12 .alertmessage').remove();
            jQuery('#field_2_12 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_2_12 .alertmessage').remove();
            jQuery('#field_2_12 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more signs your loved one might need to be reminded to drink water.</div>");
        }
        if (jQuery('#choice_2_12_4').is(':checked')) {
            jQuery('#field_2_12 .alertmessage').remove();
            jQuery('#field_2_12 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_2_12_1').is(':checked') && !jQuery('#choice_2_12_2').is(':checked') && !jQuery('#choice_2_12_3').is(':checked') && !jQuery('#choice_2_12_4').is(':checked')) {
            jQuery('#field_2_12 .alertmessage').remove();
        }

    });
    jQuery('#field_2_12').click(function() {
        if (jQuery('#choice_2_12_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_2_12_4').remove();
            jQuery('.gchoice_2_12_4 ').after("<div class='alertmessage insidecheckbox gchoice_2_12_4'> There is no evidence that dementia causes people to not like drinking water. It is usually due to other things, like forgetting to drink water. Tammy is showing several signs that she might need more support in remembering to drink more water.</div>");
        }
    });

    jQuery('#field_2_13').click(function() {
        if (jQuery('#choice_2_13_1').is(':checked') && jQuery('#choice_2_13_2').is(':checked') && jQuery('#choice_2_13_3').is(':checked') && jQuery('#choice_2_13_4').is(':checked')) {
            jQuery('#field_2_13 .alertmessage').remove();
            jQuery('#field_2_13 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_2_13 .alertmessage').remove();
            jQuery('#field_2_13 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more ways to ensure Danielle is involved.</div>");
        }

        if (!jQuery('#choice_2_13_1').is(':checked') && !jQuery('#choice_2_13_2').is(':checked') && !jQuery('#choice_2_13_3').is(':checked') && !jQuery('#choice_2_13_4').is(':checked')) {
            jQuery('#field_2_13 .alertmessage').remove();
        }

    });
    jQuery('#field_2_14').click(function() {
        if (jQuery('#choice_2_14_1').is(':checked') && jQuery('#choice_2_14_2').is(':checked') && jQuery('#choice_2_14_3').is(':checked') && jQuery('#choice_2_14_4').is(':checked')) {
            jQuery('#field_2_14 .alertmessage').remove();
            jQuery('#field_2_14 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_2_14 .alertmessage').remove();
            jQuery('#field_2_14 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – these are all a part of eating and drinking.</div>");
        }

        if (!jQuery('#choice_2_14_1').is(':checked') && !jQuery('#choice_2_14_2').is(':checked') && !jQuery('#choice_2_14_3').is(':checked') && !jQuery('#choice_2_14_4').is(':checked')) {
            jQuery('#field_2_14 .alertmessage').remove();
        }

    });
    jQuery('#field_2_8').click(function() {
        if (jQuery('#choice_2_8_0').is(':checked')) {
            jQuery('#field_2_8 .alertmessage').remove();
            jQuery('.alertmessage.gchoice_2_8_1').remove();
            jQuery('#field_2_8 .ginput_container_radio').after("<div class='alertmessage success'>Great job!</div>");
        }
    });
    jQuery('#field_2_8').click(function() {
        if (jQuery('#choice_2_8_1').is(':checked')) {
            jQuery('#field_2_8 .alertmessage').remove();
            jQuery('#field_2_8 .ginput_container_radio').after("<div class='alertmessage moreselection'>Your selection is incorrect. Please review the red text above.</div>");
        }
    });
    jQuery('#field_2_8').click(function() {
        if (!jQuery('#choice_2_8_0').is(':checked') && jQuery('#choice_2_8_1').is(':checked')) {
            jQuery('.alertmessage.gchoice_2_8_1').remove();
            jQuery('.gchoice_2_8_1 ').after("<div class='alertmessage insidecheckbox gchoice_2_8_1'> Encouraging foods high in water content can help keep a person hydrated. </div>");
        } else {
            jQuery('.alertmessage.gchoice_2_8_1').remove();
        }
    });
    jQuery('#field_2_15').click(function() {
        if (jQuery('#choice_2_15_1').is(':checked') && jQuery('#choice_2_15_2').is(':checked') && jQuery('#choice_2_15_3').is(':checked')) {
            jQuery('#field_2_15 .alertmessage').remove();
            jQuery('#field_2_15 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_2_15 .alertmessage').remove();
            jQuery('#field_2_15 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more examples of honoring your loved one’s preferences or choices.</div>");
        }

        if (jQuery('#choice_2_15_4').is(':checked')) {
            jQuery('#field_2_15 .alertmessage').remove();
            jQuery('#field_2_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_2_15_5').is(':checked')) {
            jQuery('#field_2_15 .alertmessage').remove();
            jQuery('#field_2_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        } else if (jQuery('#choice_2_15_6').is(':checked')) {
            jQuery('#field_2_15 .alertmessage').remove();
            jQuery('#field_2_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_2_15_1').is(':checked') && !jQuery('#choice_2_15_2').is(':checked') && !jQuery('#choice_2_15_3').is(':checked') && !jQuery('#choice_2_15_4').is(':checked') && !jQuery('#choice_2_15_5').is(':checked') && !jQuery('#choice_2_15_6').is(':checked')) {
            jQuery('#field_2_15 .alertmessage').remove();
        }

    });

    jQuery('#field_2_15').click(function() {
        if (jQuery('#choice_2_15_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_2_15_4').remove();
            jQuery('.gchoice_2_15_4 ').after("<div class='alertmessage insidecheckbox gchoice_2_15_4'>It is wrong for Gary to assume that it does matter to Jose what he eats or that he does not want to be involved in choosing food. Gary is not trying to honor his preferences by not asking him.</div>");
        }

    });
    jQuery('#field_2_15').click(function() {
        if (jQuery('#choice_2_15_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_2_15_5').remove();
            jQuery('.gchoice_2_15_5 ').after("<div class='alertmessage insidecheckbox gchoice_2_15_5'>While Keke might have good intentions in trying to keep Mariah from dropping food on herself by making different food, she does not ask Mariah about this, and is not honoring Mariah’s food preferences.</div>");
        }

    });
    jQuery('#field_2_15').click(function() {
        if (jQuery('#choice_2_15_6').is(':checked')) {
            jQuery('.alertmessage.gchoice_2_15_6').remove();
            jQuery('.gchoice_2_15_6 ').after("<div class='alertmessage insidecheckbox gchoice_2_15_6'>Anna also has good intentions in trying to help Christine eat, but she is not doing it in line with what Christine wants – it is important that Christine be able to choose the food she likes.</div>");
        }
    });
    /*Dressing Support*/
    jQuery('#field_7_14').click(function() {
        if (jQuery('#choice_7_14_1').is(':checked') && jQuery('#choice_7_14_2').is(':checked') && jQuery('#choice_7_14_3').is(':checked') && jQuery('#choice_7_14_4').is(':checked') && jQuery('#choice_7_14_5').is(':checked') ) {
            jQuery('#field_7_14 .alertmessage').remove();
            jQuery('#field_7_14 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_7_14 .alertmessage').remove();
            jQuery('#field_7_14 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – these are all a part of dressing.</div>");
        }
        if (!jQuery('#choice_7_14_1').is(':checked') && !jQuery('#choice_7_14_2').is(':checked') && !jQuery('#choice_7_14_3').is(':checked') && !jQuery('#choice_7_14_4').is(':checked') && !jQuery('#choice_7_14_5').is(':checked') ) {
            jQuery('#field_7_14 .alertmessage').remove();
        }

    });
    jQuery('#field_7_11').click(function() {
        if (jQuery('#choice_7_11_1').is(':checked') && jQuery('#choice_7_11_2').is(':checked') && jQuery('#choice_7_11_3').is(':checked') && jQuery('#choice_7_11_4').is(':checked') && jQuery('#choice_7_11_5').is(':checked') && jQuery('#choice_7_11_6').is(':checked') && jQuery('#choice_7_11_7').is(':checked') && jQuery('#choice_7_11_8').is(':checked')) {
            jQuery('#field_7_11 .alertmessage').remove();
            jQuery('#field_7_11 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_7_11 .alertmessage').remove();
            jQuery('#field_7_11 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – more questions can help understand your loved one’s preferences for dressing.</div>");
        }
        if (jQuery('#choice_7_11_9').is(':checked')) {
            jQuery('#field_7_11 .alertmessage').remove();
            jQuery('#field_7_11 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_7_11_1').is(':checked') && !jQuery('#choice_7_11_2').is(':checked') && !jQuery('#choice_7_11_3').is(':checked') && !jQuery('#choice_7_11_4').is(':checked') && !jQuery('#choice_7_11_5').is(':checked') && !jQuery('#choice_7_11_6').is(':checked') && !jQuery('#choice_7_11_7').is(':checked') && !jQuery('#choice_7_11_8').is(':checked') && !jQuery('#choice_7_11_9').is(':checked')) {
            jQuery('#field_7_11 .alertmessage').remove();
        }
    });
    jQuery('#field_7_11').click(function() {
        if (jQuery('#choice_7_11_9').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_11_9').remove();
            jQuery('.gchoice_7_11_9 ').after("<div class='alertmessage insidecheckbox gchoice_7_11_9'>While Keke might have good intentions in trying to keep Mariah from dropping food on herself by making different food, she does not ask Mariah about this, and is not honoring Mariah’s food preferences.</div>");
        }

    });
    jQuery('#field_7_12').click(function() {
        if (jQuery('#choice_7_12_1').is(':checked') && jQuery('#choice_7_12_2').is(':checked') && jQuery('#choice_7_12_3').is(':checked')) {
            jQuery('#field_7_12 .alertmessage').remove();
            jQuery('#field_7_12 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_7_12 .alertmessage').remove();
            jQuery('#field_7_12 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more examples of offering choices.</div>");
        }
        if (jQuery('#choice_7_12_4').is(':checked') || jQuery('#choice_7_12_5').is(':checked')) {
            jQuery('#field_7_12 .alertmessage').remove();
            jQuery('#field_7_12 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_7_12_1').is(':checked') && !jQuery('#choice_7_12_2').is(':checked') && !jQuery('#choice_7_12_3').is(':checked') && !jQuery('#choice_7_12_4').is(':checked') && !jQuery('#choice_7_12_5').is(':checked')) {
            jQuery('#field_7_12 .alertmessage').remove();
        }
    });
    jQuery('#field_7_12').click(function() {
        if (jQuery('#choice_7_12_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_12_4').remove();
            jQuery('.gchoice_7_12_4 ').after("<div class='alertmessage insidecheckbox gchoice_7_12_4'>You are making the choice for the person. It’s possible your loved one wants to wear certain clothes regardless of where they are going for the day.</div>");
        }

    });
    jQuery('#field_7_12').click(function() {
        if (jQuery('#choice_7_12_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_12_5').remove();
            jQuery('.gchoice_7_12_5 ').after("<div class='alertmessage insidecheckbox gchoice_7_12_5'>It may not make sense to you that your loved one wants to wear dresses, but it might be important to them. You could suggest different types of dresses that might be more comfortable or easier to wear, if that is the concern. Or, the person might have a clear idea of the type of dress they want to wear and we should to try to honor that.</div>");
        }

    });

    jQuery('#field_7_13').click(function() {
        if (jQuery('#choice_7_13_1').is(':checked') && jQuery('#choice_7_13_2').is(':checked') && jQuery('#choice_7_13_3').is(':checked') && jQuery('#choice_7_13_4').is(':checked') && jQuery('#choice_7_13_5').is(':checked') && jQuery('#choice_7_13_6').is(':checked') && jQuery('#choice_7_13_7').is(':checked')) {
            jQuery('#field_7_13 .alertmessage').remove();
            jQuery('#field_7_13 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_7_13 .alertmessage').remove();
            jQuery('#field_7_13 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – these are all ways that communication can help you provide helpful dressing support.</div>");
        }

        if (!jQuery('#choice_7_13_1').is(':checked') && !jQuery('#choice_7_13_2').is(':checked') && !jQuery('#choice_7_13_3').is(':checked') && !jQuery('#choice_7_13_4').is(':checked') && !jQuery('#choice_7_13_5').is(':checked') && !jQuery('#choice_7_13_6').is(':checked') && !jQuery('#choice_7_13_7').is(':checked')) {
            jQuery('#field_7_13 .alertmessage').remove();
        }
    });

    jQuery('#field_7_15').click(function() {
        if (jQuery('#choice_7_15_1').is(':checked') && jQuery('#choice_7_15_2').is(':checked') && jQuery('#choice_7_15_3').is(':checked')) {
            jQuery('#field_7_15 .alertmessage').remove();
            jQuery('#field_7_15 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_7_15 .alertmessage').remove();
            jQuery('#field_7_15 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more examples of being supportive.</div>");
        }
        if (jQuery('#choice_7_15_4').is(':checked')) {
            jQuery('#field_7_15 .alertmessage').remove();
            jQuery('#field_7_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (jQuery('#choice_7_15_5').is(':checked')) {
            jQuery('#field_7_15 .alertmessage').remove();
            jQuery('#field_7_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_7_15_1').is(':checked') && !jQuery('#choice_7_15_2').is(':checked') && !jQuery('#choice_7_15_3').is(':checked') && !jQuery('#choice_7_15_4').is(':checked') && !jQuery('#choice_7_15_5').is(':checked')) {
            jQuery('#field_7_15 .alertmessage').remove();
        }
    });
    jQuery('#field_7_15').click(function() {
        if (jQuery('#choice_7_15_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_15_4').remove();
            jQuery('.gchoice_7_15_4 ').after("<div class='alertmessage insidecheckbox gchoice_7_15_4'>Krista is assuming Darya does not want to get her clothes, and Darya might want to get her clothes even if it is difficult.</div>");
        }

    });
    jQuery('#field_7_15').click(function() {
        if (jQuery('#choice_7_15_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_15_5').remove();
            jQuery('.gchoice_7_15_5 ').after("<div class='alertmessage insidecheckbox gchoice_7_15_5'>Nico finds it easiest to dress when he is sitting on the bed so he can move around as needed and lie down to pull on his pants. Sitting in a chair does not work well for him. Gregor is not offering support in the way Nico needs – Gregor is trying to get things done to meet his own needs.</div>");
        }

    });

    jQuery('#field_7_16').click(function() {
        if (jQuery('#choice_7_16_1').is(':checked') && jQuery('#choice_7_16_2').is(':checked') && jQuery('#choice_7_16_3').is(':checked')) {
            jQuery('#field_7_16 .alertmessage').remove();
            jQuery('#field_7_16 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_7_16 .alertmessage').remove();
            jQuery('#field_7_16 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more examples of honoring preferences or choices.</div>");
        }
        if (jQuery('#choice_7_16_4').is(':checked')) {
            jQuery('#field_7_16 .alertmessage').remove();
            jQuery('#field_7_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (jQuery('#choice_7_16_5').is(':checked')) {
            jQuery('#field_7_16 .alertmessage').remove();
            jQuery('#field_7_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (jQuery('#choice_7_16_5').is(':checked')) {
            jQuery('#field_7_16 .alertmessage').remove();
            jQuery('#field_7_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_7_16_1').is(':checked') && !jQuery('#choice_7_16_2').is(':checked') && !jQuery('#choice_7_16_3').is(':checked') && !jQuery('#choice_7_16_4').is(':checked') && !jQuery('#choice_7_16_5').is(':checked') && !jQuery('#choice_7_16_6').is(':checked')) {
            jQuery('#field_7_16 .alertmessage').remove();
        }


    });

    jQuery('#field_7_16').click(function() {
        if (jQuery('#choice_7_16_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_16_4').remove();
            jQuery('.gchoice_7_16_4 ').after("<div class='alertmessage insidecheckbox gchoice_7_16_4'>Gary is not asking Jose about his preference. Gary should not assume that Jose does not care about his appearance. In fact, before his accident, Jose loved dressing up and wearing stylish clothes.</div>");
        }

    });
    jQuery('#field_7_16').click(function() {
        if (jQuery('#choice_7_16_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_16_5').remove();
            jQuery('.gchoice_7_16_5 ').after("<div class='alertmessage insidecheckbox gchoice_7_16_5'>Maria is not considering that Jay likes buttoning his shirt and fastening his pants. It makes him feel like he is not having everything done for him. </div>");
        }

    });
    jQuery('#field_7_16').click(function() {
        if (jQuery('#choice_7_16_6').is(':checked')) {
            jQuery('.alertmessage.gchoice_7_16_6').remove();
            jQuery('.gchoice_7_16_6 ').after("<div class='alertmessage insidecheckbox gchoice_7_16_6'>Not only is Anna not honoring Christine’s preferences, but she is preventing  Christine from doing her own dressing. Christine can zip up a sweater but when she wears a sweatshirt there is nothing for her to do – she cannot pull it over her head and there is nothing to zip. Christine loses the opportunity to be involved.</div>");
        }

    });

    /* Mobility Support */

    jQuery('#field_8_14').click(function() {
        if (jQuery('#choice_8_14_1').is(':checked') && jQuery('#choice_8_14_2').is(':checked') && jQuery('#choice_8_14_3').is(':checked') && jQuery('#choice_8_14_4').is(':checked') && jQuery('#choice_8_14_5').is(':checked') && jQuery('#choice_8_14_6').is(':checked') && jQuery('#choice_8_14_7').is(':checked') ) {
            jQuery('#field_8_14 .alertmessage').remove();
            jQuery('#field_8_14 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_8_14 .alertmessage').remove();
            jQuery('#field_8_14 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – All of these are a part of mobility.</div>");
        }

        if (!jQuery('#choice_8_14_1').is(':checked') && !jQuery('#choice_8_14_2').is(':checked') && !jQuery('#choice_8_14_3').is(':checked') && !jQuery('#choice_8_14_4').is(':checked') && !jQuery('#choice_8_14_5').is(':checked') && !jQuery('#choice_8_14_6').is(':checked') && !jQuery('#choice_8_14_7').is(':checked') ) {
            jQuery('#field_8_14 .alertmessage').remove();
        }


    });

    jQuery('#field_8_11').click(function() {
        if (jQuery('#choice_8_11_1').is(':checked') && jQuery('#choice_8_11_2').is(':checked') && jQuery('#choice_8_11_3').is(':checked') && jQuery('#choice_8_11_4').is(':checked') ) {
            jQuery('#field_8_11 .alertmessage').remove();
            jQuery('#field_8_11 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_8_11 .alertmessage').remove();
            jQuery('#field_8_11 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking - All of these are a part of mobility. It is important to understand your loved one’s support needs and preferences related to mobility.</div>");
        }

        if (!jQuery('#choice_8_11_1').is(':checked') && !jQuery('#choice_8_11_2').is(':checked') && !jQuery('#choice_8_11_3').is(':checked') && !jQuery('#choice_8_11_4').is(':checked') ) {
            jQuery('#field_8_11 .alertmessage').remove();
        }


    });

    jQuery('#field_8_16').click(function() {
        if (jQuery('#choice_8_16_1').is(':checked') && jQuery('#choice_8_16_2').is(':checked') && jQuery('#choice_8_16_3').is(':checked') && jQuery('#choice_8_16_4').is(':checked') ) {
            jQuery('#field_8_16 .alertmessage').remove();
            jQuery('#field_8_16 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_8_16 .alertmessage').remove();
            jQuery('#field_8_16 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more mobility communication examples.</div>");
        }

        if (!jQuery('#choice_8_16_1').is(':checked') && !jQuery('#choice_8_16_2').is(':checked') && !jQuery('#choice_8_16_3').is(':checked') && !jQuery('#choice_8_16_4').is(':checked') && !jQuery('#choice_8_16_5').is(':checked') ) {
            jQuery('#field_8_16 .alertmessage').remove();
        }


    });
    jQuery('#field_8_16').click(function() {
        if (jQuery('#choice_8_16_5').is(':checked')) {
            jQuery('#field_8_16 .alertmessage').remove();
            jQuery('#field_8_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });

    jQuery('#field_8_16').click(function() {
        if (jQuery('#choice_8_16_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_8_16_5').remove();
            jQuery('.gchoice_8_16_5').after("<div class='alertmessage insidecheckbox gchoice_8_16_5'>Communication is not telling a person what they need to do. It might be asking a person what they want, or paying attention to what a person needs through words or actions. Communication might be guiding a person to do something and supporting them to be in control.</div>");
        }

    });

    jQuery('#field_8_12').click(function() {
        if (jQuery('#choice_8_12_1').is(':checked') && jQuery('#choice_8_12_2').is(':checked') && jQuery('#choice_8_12_3').is(':checked')) {
            jQuery('#field_8_12 .alertmessage').remove();
            jQuery('#field_8_12 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_8_12 .alertmessage').remove();
            jQuery('#field_8_12 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more ways Zoe is offering the right mobility support.</div>");
        }

        if (!jQuery('#choice_8_12_1').is(':checked') && !jQuery('#choice_8_12_2').is(':checked') && !jQuery('#choice_8_12_3').is(':checked') && !jQuery('#choice_8_12_4').is(':checked') && !jQuery('#choice_8_12_5').is(':checked') ) {
            jQuery('#field_8_12 .alertmessage').remove();
        }


    });
    jQuery('#field_8_12').click(function() {
        if (jQuery('#choice_8_12_4').is(':checked') || jQuery('#choice_8_12_5').is(':checked') ) {
            jQuery('#field_8_12 .alertmessage').remove();
            jQuery('#field_8_12 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });

    jQuery('#field_8_12').click(function() {

        if (jQuery('#choice_8_12_4').is(':checked')) {
            jQuery('.alertmessage.gchoice_8_12_4').remove();
            jQuery('.gchoice_8_12_4').after("<div class='alertmessage insidecheckbox gchoice_8_12_4'>This is not what makes Renee comfortable.</div>");
        }
        if (jQuery('#choice_8_12_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_8_12_5').remove();
            jQuery('.gchoice_8_12_5').after("<div class='alertmessage insidecheckbox gchoice_8_12_5'>This is not supportive because Renee can use her arms, legs and stand, with assistance.</div>");
        }

    });

    jQuery('#field_8_17').click(function() {
        if (jQuery('#choice_8_17_1').is(':checked') && jQuery('#choice_8_17_2').is(':checked') && jQuery('#choice_8_17_3').is(':checked')) {
            jQuery('#field_8_17 .alertmessage').remove();
            jQuery('#field_8_17 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_8_17 .alertmessage').remove();
            jQuery('#field_8_17 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – There are more things to keep in mind.</div>");
        }

        if (!jQuery('#choice_8_17_1').is(':checked') && !jQuery('#choice_8_17_2').is(':checked') && !jQuery('#choice_8_17_3').is(':checked')) {
            jQuery('#field_8_17 .alertmessage').remove();
        }


    });

    jQuery('#field_8_18').click(function() {
        if (jQuery('#choice_8_18_1').is(':checked') && jQuery('#choice_8_18_2').is(':checked') && jQuery('#choice_8_18_3').is(':checked') && jQuery('#choice_8_18_4').is(':checked') && jQuery('#choice_8_18_5').is(':checked') && jQuery('#choice_8_18_6').is(':checked')) {
            jQuery('#field_8_18 .alertmessage').remove();
            jQuery('#field_8_18 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson. </div>");
        } else {
            jQuery('#field_8_18 .alertmessage').remove();
            jQuery('#field_8_18 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – More questions would help understand a person’s mobility preferences.</div>");
        }

        if (!jQuery('#choice_8_18_1').is(':checked') && !jQuery('#choice_8_18_2').is(':checked') && !jQuery('#choice_8_18_3').is(':checked') && !jQuery('#choice_8_18_4').is(':checked') && !jQuery('#choice_8_18_5').is(':checked') && !jQuery('#choice_8_18_6').is(':checked')) {
            jQuery('#field_8_18 .alertmessage').remove();
        }


    });

    jQuery('#field_9_14').click(function() {
        if (jQuery('#choice_9_14_1').is(':checked') && jQuery('#choice_9_14_2').is(':checked') && jQuery('#choice_9_14_3').is(':checked') && jQuery('#choice_9_14_4').is(':checked') && jQuery('#choice_9_14_5').is(':checked') && jQuery('#choice_9_14_6').is(':checked') && jQuery('#choice_9_14_7').is(':checked')) {
            jQuery('#field_9_14 .alertmessage').remove();
            jQuery('#field_9_14 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_9_14 .alertmessage').remove();
            jQuery('#field_9_14 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – All of these are a part of continence support.</div>");
        }

        if (!jQuery('#choice_9_14_1').is(':checked') && !jQuery('#choice_9_14_2').is(':checked') && !jQuery('#choice_9_14_3').is(':checked') && !jQuery('#choice_9_14_4').is(':checked') && !jQuery('#choice_9_14_5').is(':checked') && !jQuery('#choice_9_14_6').is(':checked') && !jQuery('#choice_9_14_7').is(':checked') ) {
            jQuery('#field_9_14 .alertmessage').remove();
        }


    });
    jQuery('#field_9_11').click(function() {
        if (jQuery('#choice_9_11_1').is(':checked') && jQuery('#choice_9_11_2').is(':checked') && jQuery('#choice_9_11_3').is(':checked') && jQuery('#choice_9_11_4').is(':checked')) {
            jQuery('#field_9_11 .alertmessage').remove();
            jQuery('#field_9_11 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_9_11 .alertmessage').remove();
            jQuery('#field_9_11 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more words you should use for an incontinence product.</div>");
        }
        if (jQuery('#choice_9_11_5').is(':checked')) {
            jQuery('#field_9_11 .alertmessage').remove();
            jQuery('#field_9_11 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
        if (!jQuery('#choice_9_11_1').is(':checked') && !jQuery('#choice_9_11_2').is(':checked') && !jQuery('#choice_9_11_3').is(':checked') && !jQuery('#choice_9_11_4').is(':checked') && !jQuery('#choice_9_11_5').is(':checked')) {
            jQuery('#field_9_11 .alertmessage').remove();
        }


    });
    jQuery('#field_9_11').click(function() {
        if (jQuery('#choice_9_11_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_9_11_5').remove();
            jQuery('.gchoice_9_11_5').after("<div class='alertmessage insidecheckbox gchoice_9_11_5'>When you use the word diaper for an adult it can take away your loved one’s dignity and make them feel like they are being treated as a child.</div>");
        }

    });

    jQuery('#field_9_12').click(function() {
        if (jQuery('#choice_9_12_1').is(':checked') && jQuery('#choice_9_12_2').is(':checked') && jQuery('#choice_9_12_3').is(':checked') && jQuery('#choice_9_12_4').is(':checked') && jQuery('#choice_9_12_5').is(':checked')) {
            jQuery('#field_9_12 .alertmessage').remove();
            jQuery('#field_9_12 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_9_12 .alertmessage').remove();
            jQuery('#field_9_12 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking - All of these are important to maintain good health.</div>");
        }

        if (!jQuery('#choice_9_12_1').is(':checked') && !jQuery('#choice_9_12_2').is(':checked') && !jQuery('#choice_9_12_3').is(':checked') && !jQuery('#choice_9_12_4').is(':checked') && !jQuery('#choice_9_12_5').is(':checked')) {
            jQuery('#field_9_12 .alertmessage').remove();
        }


    });

    jQuery('#field_9_13').click(function() {
        if (jQuery('#choice_9_13_1').is(':checked') && jQuery('#choice_9_13_2').is(':checked') && jQuery('#choice_9_13_3').is(':checked') && jQuery('#choice_9_13_4').is(':checked') && jQuery('#choice_9_13_5').is(':checked')) {
            jQuery('#field_9_13 .alertmessage').remove();
            jQuery('#field_9_13 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_9_13 .alertmessage').remove();
            jQuery('#field_9_13 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – All of these are important to offering the right support.</div>");
        }

        if (!jQuery('#choice_9_13_1').is(':checked') && !jQuery('#choice_9_13_2').is(':checked') && !jQuery('#choice_9_13_3').is(':checked') && !jQuery('#choice_9_13_4').is(':checked') && !jQuery('#choice_9_13_5').is(':checked')) {
            jQuery('#field_9_13 .alertmessage').remove();
        }


    });
    jQuery('#field_9_15').click(function() {
        if (jQuery('#choice_9_15_1').is(':checked') && jQuery('#choice_9_15_2').is(':checked') && jQuery('#choice_9_15_3').is(':checked')) {
            jQuery('#field_9_15 .alertmessage').remove();
            jQuery('#field_9_15 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_9_15 .alertmessage').remove();
            jQuery('#field_9_15 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking - All of these help to honor Karina’s preferences.</div>");
        }

        if (!jQuery('#choice_9_15_1').is(':checked') && !jQuery('#choice_9_15_2').is(':checked') && !jQuery('#choice_9_15_3').is(':checked')) {
            jQuery('#field_9_15 .alertmessage').remove();
        }


    });

    jQuery('#field_9_16').click(function() {
        if (jQuery('#choice_9_16_1').is(':checked') && jQuery('#choice_9_16_2').is(':checked') && jQuery('#choice_9_16_3').is(':checked') && jQuery('#choice_9_16_4').is(':checked')) {
            jQuery('#field_9_16 .alertmessage').remove();
            jQuery('#field_9_16 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_9_16 .alertmessage').remove();
            jQuery('#field_9_16 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – There are more examples of Jade providing Kathy the right support.</div>");
        }

        if (!jQuery('#choice_9_16_1').is(':checked') && !jQuery('#choice_9_16_2').is(':checked') && !jQuery('#choice_9_16_3').is(':checked') && !jQuery('#choice_9_16_4').is(':checked') && !jQuery('#choice_9_16_5').is(':checked') && !jQuery('#choice_9_16_6').is(':checked')) {
            jQuery('#field_9_16 .alertmessage').remove();
        }


    });

    jQuery('#field_9_16').click(function() {
        if (jQuery('#choice_9_16_5').is(':checked') || jQuery('#choice_9_16_6').is(':checked')) {
            jQuery('#field_9_16 .alertmessage').remove();
            jQuery('#field_9_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One or more of your selections is incorrect. Please review the red text above.</div>");
        }
    });

    jQuery('#field_9_16').click(function() {
        if (jQuery('#choice_9_16_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_9_16_5').remove();
            jQuery('.gchoice_9_16_5').after("<div class='alertmessage insidecheckbox gchoice_9_16_5'>Kathy does not want Jade to be in the bathroom with her the whole time. Kathy can do things on her own. Insisting on being in the bathroom with Kathy is not the type of support Kathy wants or needs.</div>");
        }
        if (jQuery('#choice_9_16_6').is(':checked')) {
            jQuery('.alertmessage.gchoice_9_16_6').remove();
            jQuery('.gchoice_9_16_6').after("<div class='alertmessage insidecheckbox gchoice_9_16_6'>Kathy has explained to Jade that she does not like all this stuff on the sink because she knocks things over and they either fall in the sink or on the floor and this stresses her out. This is not what Kathy wants and is making things more difficult for her.</div>");
        }


    });
    /*Restroom Support Quiz*/

    jQuery('#field_10_14').click(function() {
        if (jQuery('#choice_10_14_1').is(':checked') && jQuery('#choice_10_14_2').is(':checked') && jQuery('#choice_10_14_3').is(':checked') && jQuery('#choice_10_14_4').is(':checked') && jQuery('#choice_10_14_5').is(':checked') && jQuery('#choice_10_14_6').is(':checked') && jQuery('#choice_10_14_7').is(':checked') ) {
            jQuery('#field_10_14 .alertmessage').remove();
            jQuery('#field_10_14 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_10_14 .alertmessage').remove();
            jQuery('#field_10_14 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – All of these are a part of using the restroom.</div>");
        }

        if (!jQuery('#choice_10_14_1').is(':checked') && !jQuery('#choice_10_14_2').is(':checked') && !jQuery('#choice_10_14_3').is(':checked') && !jQuery('#choice_10_14_4').is(':checked') && !jQuery('#choice_10_14_5').is(':checked') && !jQuery('#choice_10_14_6').is(':checked') && !jQuery('#choice_10_14_7').is(':checked') ) {
            jQuery('#field_10_14 .alertmessage').remove();
        }


    });

    jQuery('#field_10_11').click(function() {
        if (jQuery('#choice_10_11_1').is(':checked') && jQuery('#choice_10_11_2').is(':checked') && jQuery('#choice_10_11_3').is(':checked') && jQuery('#choice_10_11_4').is(':checked') ) {
            jQuery('#field_10_11 .alertmessage').remove();
            jQuery('#field_10_11 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_10_11 .alertmessage').remove();
            jQuery('#field_10_11 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more ways you might help your loved one in the restroom.</div>");
        }

        if (!jQuery('#choice_10_11_1').is(':checked') && !jQuery('#choice_10_11_2').is(':checked') && !jQuery('#choice_10_11_3').is(':checked') && !jQuery('#choice_10_11_4').is(':checked') && !jQuery('#choice_10_11_5').is(':checked') ) {
            jQuery('#field_10_11 .alertmessage').remove();
        }


    });

    jQuery('#field_10_11').click(function() {
        if (jQuery('#choice_10_11_5').is(':checked')) {
            jQuery('#field_10_11 .alertmessage').remove();
            jQuery('#field_10_11 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });

    jQuery('#field_10_11').click(function() {
        if (jQuery('#choice_10_11_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_10_11_5').remove();
            jQuery('.gchoice_10_11_5').after("<div class='alertmessage insidecheckbox gchoice_10_11_5'>Each situation is different, but it would not be offering support if we kept a person from using a toilet just because there might be some mess.</div>");
        }
    });

    jQuery('#field_10_12').click(function() {
        if (jQuery('#choice_10_12_1').is(':checked') && jQuery('#choice_10_12_2').is(':checked') && jQuery('#choice_10_12_3').is(':checked') && jQuery('#choice_10_12_4').is(':checked') ) {
            jQuery('#field_10_12 .alertmessage').remove();
            jQuery('#field_10_12 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_10_12 .alertmessage').remove();
            jQuery('#field_10_12 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking - It’s possible a person might not have specific preferences, but even asking about their preferences sends the message that you are giving them control.</div>");
        }

        if (!jQuery('#choice_10_12_1').is(':checked') && !jQuery('#choice_10_12_2').is(':checked') && !jQuery('#choice_10_12_3').is(':checked') && !jQuery('#choice_10_12_4').is(':checked') ) {
            jQuery('#field_10_12 .alertmessage').remove();
        }


    });

    jQuery('#field_10_13').click(function() {
        if (jQuery('#choice_10_13_1').is(':checked') && jQuery('#choice_10_13_2').is(':checked') && jQuery('#choice_10_13_3').is(':checked') && jQuery('#choice_10_13_4').is(':checked') ) {
            jQuery('#field_10_13 .alertmessage').remove();
            jQuery('#field_10_13 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_10_13 .alertmessage').remove();
            jQuery('#field_10_13 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more ways Anita can support Ginny.</div>");
        }

        if (!jQuery('#choice_10_13_1').is(':checked') && !jQuery('#choice_10_13_2').is(':checked') && !jQuery('#choice_10_13_3').is(':checked') && !jQuery('#choice_10_13_4').is(':checked') && !jQuery('#choice_10_13_5').is(':checked') ) {
            jQuery('#field_10_13 .alertmessage').remove();
        }


    });

    jQuery('#field_10_13').click(function() {
        if (jQuery('#choice_10_13_5').is(':checked')) {
            jQuery('#field_10_13 .alertmessage').remove();
            jQuery('#field_10_13 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });

    jQuery('#field_10_13').click(function() {
        if (jQuery('#choice_10_13_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_10_13_5').remove();
            jQuery('.gchoice_10_13_5').after("<div class='alertmessage insidecheckbox gchoice_10_13_5'>It doesn’t seem that Ginny is totally incontinent because she will use the toilet most of the time – she just seems to have sudden urges where she can’t get to the bathroom on time or might not realize she has to go at that moment. It is important to still try to help her use the restroom so she can retain this ability for as long as possible.</div>");
        }
    });


    jQuery('#field_10_15').click(function() {
        if (jQuery('#choice_10_15_1').is(':checked') && jQuery('#choice_10_15_2').is(':checked') && jQuery('#choice_10_15_3').is(':checked') && jQuery('#choice_10_15_4').is(':checked')) {
            jQuery('#field_10_15 .alertmessage').remove();
            jQuery('#field_10_15 .ginput_container_checkbox').after("<div class='alertmessage success'>Great job!</div>");
        } else {
            jQuery('#field_10_15 .alertmessage').remove();
            jQuery('#field_10_15 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more things Ginger can do to support Connie.</div>");
        }

        if (!jQuery('#choice_10_15_1').is(':checked') && !jQuery('#choice_10_15_2').is(':checked') && !jQuery('#choice_10_15_3').is(':checked') && !jQuery('#choice_10_15_4').is(':checked') && !jQuery('#choice_10_15_5').is(':checked')) {
            jQuery('#field_10_15 .alertmessage').remove();
        }


    });

    jQuery('#field_10_15').click(function() {
        if (jQuery('#choice_10_15_5').is(':checked')) {
            jQuery('#field_10_15 .alertmessage').remove();
            jQuery('#field_10_15 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });

    jQuery('#field_10_15').click(function() {
        if (jQuery('#choice_10_15_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_10_15_5').remove();
            jQuery('.gchoice_10_15_5').after("<div class='alertmessage insidecheckbox gchoice_10_15_5'>Threatening Connie to take away something she likes if she is not doing something Ginger would like her to do is not a good approach. It doesn’t solve the issue of why Connie might not want to use the restroom, and it can hurt the relationship. It also sends the message to Connie that she is not in charge, which is not supportive.</div>");
        }
    });

    jQuery('#field_10_16').click(function() {
        if (jQuery('#choice_10_16_1').is(':checked') && jQuery('#choice_10_16_2').is(':checked') && jQuery('#choice_10_16_3').is(':checked') && jQuery('#choice_10_16_4').is(':checked') ) {
            jQuery('#field_10_16 .alertmessage').remove();
            jQuery('#field_10_16 .ginput_container_checkbox').after("<div class='alertmessage success'>Well done! You’ve completed the lesson.</div>");
        } else {
            jQuery('#field_10_16 .alertmessage').remove();
            jQuery('#field_10_16 .ginput_container_checkbox').after("<div class='alertmessage keepclicking'>Keep clicking – there are more selections that show Tom’s support for Alphie.</div>");
        }

        if (!jQuery('#choice_10_16_1').is(':checked') && !jQuery('#choice_10_16_2').is(':checked') && !jQuery('#choice_10_16_3').is(':checked') && !jQuery('#choice_10_16_4').is(':checked') && !jQuery('#choice_10_15_5').is(':checked') ) {
            jQuery('#field_10_16 .alertmessage').remove();
        }


    });

    jQuery('#field_10_16').click(function() {
        if (jQuery('#choice_10_16_5').is(':checked')) {
            jQuery('#field_10_16 .alertmessage').remove();
            jQuery('#field_10_16 .ginput_container_checkbox').after("<div class='alertmessage moreselection'>One of your selections is incorrect. Please review the red text above.</div>");
        }
    });

    jQuery('#field_10_16').click(function() {
        if (jQuery('#choice_10_16_5').is(':checked')) {
            jQuery('.alertmessage.gchoice_10_16_5').remove();
            jQuery('.gchoice_10_16_5').after("<div class='alertmessage insidecheckbox gchoice_10_16_5'>Alphie can still use the restroom, although he needs a lot of support to do so. As long as he can go to the restroom, Tom should support him to do this to help Alphie maintain continence as long as possible.</div>");
        }
    });

});
jQuery( document ).ready(function() {
    jQuery(".cdp-card-array .px-5.py-4.space-y-2 .space-y-1 > a:contains('Workshop')").html("");
    jQuery('.cdp-card-array section .col-span-1 .font-black.text-base.text-red-accessible.mt-auto.px-5 a').text('Learn more');
    jQuery('.cdp-card-array section .col-span-1 .font-black.text-base.text-red-accessible.mt-auto.px-5').show();
    jQuery("#loadmore").on("click", function() {
        jQuery(".state-list .summerttext").removeClass('readmore');
        jQuery("#loadmore").attr("disabled", true);

    });
    jQuery('div.state-list .inner.paddingInner h2').click(function(e) {
        jQuery(this).parent().find('.textInner').slideToggle(function() { 
            var property = jQuery(this).parent().find('.textInner').css('display');
            if(property == 'block')
            var property = jQuery(this).parent().addClass("open");
            else
            var property = jQuery(this).parent().removeClass("open");
        });
    });
});